document.addEventListener('DOMContentLoaded', function () {
  checkPage()

  function checkPage() {
    let loginContent = document.querySelector('#login')
    let resetContent = document.querySelector('.recover')

    if (window.location.href.includes('recover')) {
      loginContent.classList.add('hidden')
      resetContent.classList.remove('hidden')
    } else {
      loginContent.classList.remove('hidden')
      resetContent.classList.add('hidden')
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('return_to')) {
      for (const input of document.querySelectorAll('[name="return_to"]')) {
        input.value = urlParams.get('return_to')
      }
    }
  }

  window.addEventListener('hashchange', function () {
    window.scrollTo(0, 0)

    checkPage()
  })
})
